<template>
  <form @submit.prevent="update()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="partnerInfoEditModalLabel">Add Car</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          ref="modalCloseBtn"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="card text-white"
          style="background-color: #3e454d; margin-bottom: 15px"
        >
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label for="car_type">গাড়ির ধরন</label>
                <select
                  v-model="formValue.car_type"
                  class="form-select"
                  required
                >
                  <option value="">নির্বাচন করুন</option>
                  <option
                    v-for="carType in carTypeList"
                    :key="carType.id"
                    :value="carType.id"
                  >
                    {{ carType.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="car_brand">গাড়ির ব্র্যান্ড</label>
                <select
                  v-model="formValue.car_brand"
                  class="form-select"
                  required
                >
                  <option value="">নির্বাচন করুন</option>
                  <option
                    v-for="carBrand in carBrandList"
                    :key="carBrand.id"
                    :value="carBrand.id"
                  >
                    {{ carBrand.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="car_model">গাড়ির মডেল</label>
                  <select
                    v-model="formValue.car_model"
                    class="form-select"
                    required
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option
                      v-for="carModel in carModelList"
                      :key="carModel.id"
                      :value="carModel.id"
                    >
                      {{ carModel.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label for="license_plate_number">লাইসেন্স প্লেট নাম্বার</label>
                <input
                  class="form-control"
                  v-model="formValue.license_plate_number"
                  type="text"
                  placeholder="টাইপ করুন (৭-১০ ডিজিটের মধ্যে)"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card bg-default">
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির রেজিস্ট্রেশন কাগজ'"
                  :param="'registration_number'"
                  :preview="preview['registration_number']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="registration_number"
                  @change="changePhoto('registration_number')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ট্যাক্স টোকেন'"
                  :param="'tax_token'"
                  :preview="preview['tax_token']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="tax_token"
                  @change="changePhoto('tax_token')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ফিটনেস সার্টিফিকেট'"
                  :param="'fitness_certificate'"
                  :preview="preview['fitness_certificate']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="fitness_certificate"
                  @change="changePhoto('fitness_certificate')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(front)'"
                  :param="'car_image'"
                  :preview="preview['car_image']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_image"
                  @change="changePhoto('car_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(back)'"
                  :param="'car_back_image'"
                  :preview="preview['car_back_image']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_back_image"
                  @change="changePhoto('car_back_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(side)'"
                  :param="'car_side_image'"
                  :preview="preview['car_side_image']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_side_image"
                  @change="changePhoto('car_side_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(interior)'"
                  :param="'car_interior_image'"
                  :preview="preview['car_interior_image']"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_interior_image"
                  @change="changePhoto('car_interior_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary">Submit</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';
import ImageCard from './imageCard.vue';

export default {
  props: ['baseUrl', 'partner', 'carTypeList', 'carBrandList', 'carModelList'],
  components: {
    ImageCard
  },
  data() {
    return {
      formValue: {
        car_brand: '',
        car_model: '',
        car_type: '',
        fitness_certificate: '',
        user_id: null,
        license_plate_number: '',
        registration_number: '',
        tax_token: '',
        user_token: localStorage.getItem('token')
      },
      allPartnerInfo: [],
      preview: {
        registration_number: null,
        fitness_certificate: null,
        tax_token: null,
        car_image: null,
        car_back_image: null,
        car_side_image: null,
        car_interior_image: null
      },
      previewTitle: {
        registration_number: 'গাড়ির রেজিস্ট্রেশন কাগজ',
        fitness_certificate: 'ফিটনেস সার্টিফিকেট',
        tax_token: 'ট্যাক্স টোকেন',
        car_image: 'গাড়ির ছবি(front)',
        car_back_image: 'গাড়ির ছবি(back)',
        car_side_image: 'গাড়ির ছবি(side)',
        car_interior_image: 'গাড়ির ছবি(interior)'
      },
      isLoading: false,
      carPartnerInfo: {}
    };
  },
  watch: {
    partner: function () {
      if (this.partner) {
        this.formValue.user_id = this.partner.user_id;
      }
      this.emptyFormValues();
      this.emptyPhotoPreviews();
    }
  },
  methods: {
    emptyPhotoPreviews() {
      for (const key in this.preview) {
        this.preview[key] = null;
      }
    },
    emptyFormValues() {
      this.formValue.car_brand = '';
      this.formValue.car_model = '';
      this.formValue.car_type = '';
      this.formValue.fitness_certificate = '';
      this.formValue.license_plate_number = '';
      this.formValue.registration_number = '';
      this.formValue.tax_token = '';
    },
    selectPhoto(param) {
      this.$refs[param].click();
    },
    changePhoto(param) {
      let reader = new FileReader();
      reader.onload = (e) => (this.preview[param] = e.target.result);
      reader.readAsDataURL(this.$refs[param].files[0]);
    },
    removePhoto(param) {
      this.preview[param] = null;
      this.$refs[param].value = this.$refs[param].defaultValue;
    },
    previewPhoto(param) {
      let _this = this;
      let images = [];
      let index = 0;
      let selectedImageIndex = 0;

      function pushImage(key, imagePath) {
        images.push({
          name: _this.previewTitle[key],
          path: imagePath
        });
        if (param == key) {
          selectedImageIndex = index;
        }
        index++;
      }

      for (const key in this.preview) {
        if (this.preview[key]) {
          pushImage(key, this.preview[key]);
        } else if (this.carPartnerInfo && this.carPartnerInfo[key]) {
          pushImage(key, this.baseUrl + 'upload/' + this.carPartnerInfo[key]);
        }
      }

      this.emitter.emit('setImagesForImageViewer', {
        images,
        selectedImageIndex
      });
      this.emitter.emit('showImageViewer');
    },
    update() {
      this.isLoading = true;
      // Making of the form
      let formData = new FormData();
      Object.keys(this.formValue).map((e) => {
        if (this.formValue[e]) {
          formData.append(e, this.formValue[e]);
        }
      });
      Object.keys(this.preview).map((e) => {
        if (this.preview[e]) {
          formData.append(e, this.$refs[e].files[0]);
        }
      });

      http
        .post('/v2/partners/carAdd', formData)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.emptyFormValues();
            this.emptyPhotoPreviews();
            this.$emit('refreshPaginationData');
            this.$refs.modalCloseBtn.click();
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', error.response.data.message, 'error');
        });
    }
  }
};
</script>

<style scoped>
select,
input {
  margin-bottom: 10px;
}
</style>
